export default __webpack_public_path__ + "static/HES-SO_INTERVIEWS_CLEMENT-ee3d8c55461e7a932c0c94b5514ac7f1.jpg";